export enum IconTypeEnum {
  System = 1,
  Custom = 2
}
